import { CursorContextProvider, Cursor } from "../components/general/Cursor";
import Nav from "../components/general/Nav";
import Hero from "../components/portfolio/Hero";
import Info from "../components/portfolio/Info";
import ToBlog from "../components/portfolio/ToBlog";
import CurrentComp from "../components/portfolio/CurrentComp";
// import DemoCountdown from "../components/countdown/DemoCountdown";

function Portfolio() {
  return (
    <CursorContextProvider>
      <Cursor />
      {/* <DemoCountdown /> */}
      <Hero />
      <Info />
      {/* <CurrentCompanies /> */}
      <CurrentComp />
      {/* <PrevCompanies /> */}
      <ToBlog />
      <Nav color={0} home={1} />
    </CursorContextProvider>
  );
}

export default Portfolio;
